import { render, staticRenderFns } from "./frmbefizetes.vue?vue&type=template&id=a6bfb7f4&scoped=true&"
import script from "./frmbefizetes.vue?vue&type=script&lang=js&"
export * from "./frmbefizetes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bfb7f4",
  null
  
)

export default component.exports